export const SETS = [
  // ─── BASE SETS ───────────────────────────────────────────────────────────
  {
    id: 'finest-base', type: 'base', title: 'FINEST BASE SET — 75 CARDS',
    parallels: [
      { id: 'refractor',      name: 'Refractor',              odds: '1:1',   print_run: null, color: '#c8d8f0' },
      { id: 'green',          name: 'Green Refractor',         odds: '1:4',   print_run: 99,   color: '#00e676' },
      { id: 'purple-lazer',   name: 'Purple Lazer Refractor',  odds: '1:5',   print_run: 75,   color: '#ce93d8' },
      { id: 'gold',           name: 'Gold Refractor',          odds: '1:7',   print_run: 50,   color: '#f0c040' },
      { id: 'orange',         name: 'Orange Refractor',        odds: '1:13',  print_run: 25,   color: '#ff9100' },
      { id: 'black',          name: 'Black Refractor',         odds: '1:31',  print_run: 10,   color: '#616161' },
      { id: 'red',            name: 'Red Refractor',           odds: '1:62',  print_run: 5,    color: '#ff1744' },
      { id: 'superfractor',   name: 'Superfractor',            odds: '1:313', print_run: 1,    color: '#ffd700' },
    ],
    cards: [
      {n:'F-1', name:'Luke Skywalker'},
      {n:'F-2', name:'Han Solo'},
      {n:'F-3', name:'Leia Organa'},
      {n:'F-4', name:'Grogu'},
      {n:'F-5', name:'Shin Hati'},
      {n:'F-6', name:'Jedi Master Sol'},
      {n:'F-7', name:'Ahsoka Tano'},
      {n:'F-8', name:'BB-8'},
      {n:'F-9', name:'Qui-Gon Jinn'},
      {n:'F-10', name:'Padmé Amidala'},
      {n:'F-11', name:'Captain Typho'},
      {n:'F-12', name:'Hera Syndulla'},
      {n:'F-13', name:'L3-37'},
      {n:'F-14', name:'Saw Gerrera'},
      {n:'F-15', name:'Aayla Secura'},
      {n:'F-16', name:'Yoda'},
      {n:'F-17', name:'Beru Lars'},
      {n:'F-18', name:'Ezra Bridger'},
      {n:'F-19', name:'Ki-Adi-Mundi'},
      {n:'F-20', name:'Obi-Wan Kenobi'},
      {n:'F-21', name:'IG-11'},
      {n:'F-22', name:'Sergeant Melshi'},
      {n:'F-23', name:'Syril Karn'},
      {n:'F-24', name:'Bo-Katan Kryze'},
      {n:'F-25', name:'Grand Admiral Thrawn'},
      {n:'F-26', name:'General Antoc Merrick'},
      {n:'F-27', name:'Mon Mothma'},
      {n:'F-28', name:'Garazeb Orrelios'},
      {n:'F-29', name:'The Modifier'},
      {n:'F-30', name:'Rey'},
      {n:'F-31', name:'Omega'},
      {n:'F-32', name:'Salacious B. Crumb'},
      {n:'F-33', name:'Migs Mayfeld'},
      {n:'F-34', name:'Jar Jar Binks'},
      {n:'F-35', name:'Tobias Beckett'},
      {n:'F-36', name:'Shaak Ti'},
      {n:'F-37', name:'Jawa'},
      {n:'F-38', name:'Major Partagaz'},
      {n:'F-39', name:'B2EM0'},
      {n:'F-40', name:'C-3PO'},
      {n:'F-41', name:'Nien Nunb'},
      {n:'F-42', name:'Axe Woves'},
      {n:'F-43', name:'The Seventh Sister'},
      {n:'F-44', name:'Sebulba'},
      {n:'F-45', name:'Finn'},
      {n:'F-46', name:'General Hux'},
      {n:'F-47', name:'Carson Teva'},
      {n:'F-48', name:'K-2SO'},
      {n:'F-49', name:'Greedo'},
      {n:'F-50', name:'Cassian Andor'},
      {n:'F-51', name:'The Client'},
      {n:'F-52', name:'Bossk'},
      {n:'F-53', name:'Captain Bombardier'},
      {n:'F-54', name:'General Maximilian Veers'},
      {n:'F-55', name:'Cobb Vanth'},
      {n:'F-56', name:'Mae Aniseya'},
      {n:'F-57', name:'Bail Organa'},
      {n:'F-58', name:'Fennec Shand'},
      {n:'F-59', name:'Galen Erso'},
      {n:'F-60', name:'Lando Calrissian'},
      {n:'F-61', name:'Maz Kanata'},
      {n:'F-62', name:'Baze Malbus'},
      {n:'F-63', name:'Peli Motto'},
      {n:'F-64', name:'Rose Tico'},
      {n:'F-65', name:'Jango Fett'},
      {n:'F-66', name:'Clone Commander Cody'},
      {n:'F-67', name:'Dexter Jettster'},
      {n:'F-68', name:'Yord Fandar'},
      {n:'F-69', name:'Max Rebo'},
      {n:'F-70', name:'General Grievous'},
      {n:'F-71', name:'Shmi Skywalker'},
      {n:'F-72', name:"Qi'ra"},
      {n:'F-73', name:'Neel'},
      {n:'F-74', name:'Jod Na Nawood'},
      {n:'F-75', name:'Porg'},
    ]
  },
  {
    id: 'chrome-black-base', type: 'base', title: 'CHROME BLACK BASE SET — 75 CARDS',
    parallels: [
      { id: 'cb-gold',           name: 'Gold Refractor',      odds: '1:7',   print_run: 50,   color: '#f0c040' },
      { id: 'cb-orange',         name: 'Orange Refractor',    odds: '1:13',  print_run: 25,   color: '#ff9100' },
      { id: 'magenta-ray-wave',  name: 'Magenta Ray Wave Refractor',    odds: '1:31',  print_run: 10,   color: '#e91e63' },
      { id: 'cb-red',            name: 'Red Refractor',       odds: '1:62',  print_run: 5,    color: '#ff1744' },
      { id: 'cb-superfractor',   name: 'Superfractor',        odds: '1:313', print_run: 1,    color: '#ffd700' },
    ],
    cards: [
      {n:'CB-1', name:'Darth Vader'},
      {n:'CB-2', name:'Chewbacca'},
      {n:'CB-3', name:'Grand Moff Tarkin'},
      {n:'CB-4', name:'The Mandalorian'},
      {n:'CB-5', name:'Baylan Skoll'},
      {n:'CB-6', name:'The Stranger'},
      {n:'CB-7', name:'Morgan Elsbeth'},
      {n:'CB-8', name:'D-O'},
      {n:'CB-9', name:'Mace Windu'},
      {n:'CB-10', name:'Anakin Skywalker'},
      {n:'CB-11', name:'Zam Wesell'},
      {n:'CB-12', name:'Kanan Jarrus'},
      {n:'CB-13', name:'HK-87'},
      {n:'CB-14', name:'Director Orson Krennic'},
      {n:'CB-15', name:'Plo Koon'},
      {n:'CB-16', name:'Count Dooku'},
      {n:'CB-17', name:'Owen Lars'},
      {n:'CB-18', name:'Sabine Wren'},
      {n:'CB-19', name:'Kit Fisto'},
      {n:'CB-20', name:'Darth Maul'},
      {n:'CB-21', name:'IG-88'},
      {n:'CB-22', name:'Freedi Pamular'},
      {n:'CB-23', name:'Dedra Meero'},
      {n:'CB-24', name:'The Armorer'},
      {n:'CB-25', name:'Captain Enoch'},
      {n:'CB-26', name:'Pirate Captain Brutus'},
      {n:'CB-27', name:'Luthen Rael'},
      {n:'CB-28', name:'Chopper'},
      {n:'CB-29', name:'Bib Fortuna'},
      {n:'CB-30', name:'Kylo Ren'},
      {n:'CB-31', name:'Asajj Ventress'},
      {n:'CB-32', name:'Jabba The Hutt'},
      {n:'CB-33', name:'Snowball'},
      {n:'CB-34', name:'Kelleran Beq'},
      {n:'CB-35', name:'Dryden Vos'},
      {n:'CB-36', name:'Barriss Offee'},
      {n:'CB-37', name:'Tusken Raider'},
      {n:'CB-38', name:'Moff Gideon'},
      {n:'CB-39', name:'Bix Caleen'},
      {n:'CB-40', name:'R2-D2'},
      {n:'CB-41', name:'Admiral Ackbar'},
      {n:'CB-42', name:'Paz Vizsla'},
      {n:'CB-43', name:'Marrok'},
      {n:'CB-44', name:'Gamorrean Guard'},
      {n:'CB-45', name:'Poe Dameron'},
      {n:'CB-46', name:'Supreme Leader Snoke'},
      {n:'CB-47', name:'Wedge Antilles'},
      {n:'CB-48', name:'SM-33'},
      {n:'CB-49', name:'Rancor'},
      {n:'CB-50', name:'Jyn Erso'},
      {n:'CB-51', name:'Dr. Pershing'},
      {n:'CB-52', name:'Kawlan Roken'},
      {n:'CB-53', name:'Commissioner Helgait'},
      {n:'CB-54', name:'Stormtrooper'},
      {n:'CB-55', name:'Cad Bane'},
      {n:'CB-56', name:'Osha Aniseya'},
      {n:'CB-57', name:'Sly Moore'},
      {n:'CB-58', name:'Krrsantan'},
      {n:'CB-59', name:'Edrio Two Tubes'},
      {n:'CB-60', name:'Lobot'},
      {n:'CB-61', name:'Zorii Bliss'},
      {n:'CB-62', name:'Chirrut Îmwe'},
      {n:'CB-63', name:'Greef Karga'},
      {n:'CB-64', name:'DJ'},
      {n:'CB-65', name:'Boba Fett'},
      {n:'CB-66', name:'Darth Sidious'},
      {n:'CB-67', name:'Wat Tambor'},
      {n:'CB-68', name:'Jecki Lon'},
      {n:'CB-69', name:"Figrin D'an"},
      {n:'CB-70', name:'Nute Gunray'},
      {n:'CB-71', name:'Watto'},
      {n:'CB-72', name:'Enfys Nest'},
      {n:'CB-73', name:'Bodhi Rook'},
      {n:'CB-74', name:'Tala Durith'},
      {n:'CB-75', name:'Wicket W. Warrick'},
    ]
  },
  {
    id: 'galactic-antiquities-base', type: 'base', title: 'GALACTIC ANTIQUITIES BASE SET — 50 CARDS',
    parallels: [
      { id: 'blue-foil',       name: 'Blue Foil',       odds: '1:10',  print_run: 50,   color: '#2979ff' },
      { id: 'orange-foil',     name: 'Orange Foil',     odds: '1:19',  print_run: 25,   color: '#ff9100' },
      { id: 'black-foil',      name: 'Black Foil',      odds: '1:46',  print_run: 10,   color: '#616161' },
      { id: 'red-foil',        name: 'Red Foil',        odds: '1:93',  print_run: 5,    color: '#ff1744' },
      { id: 'gold-foil',       name: 'Gold Foil',       odds: '1:472', print_run: 1,    color: '#f0c040' },
      { id: 'hyperspace-foil', name: 'Hyperspace Foil', odds: '1:472', print_run: 1,    color: '#00e5ff' },
    ],
    cards: [
      {n:'GA-1', name:'Darth Vader'},
      {n:'GA-2', name:'Luke Skywalker'},
      {n:'GA-3', name:'Han Solo'},
      {n:'GA-4', name:'Kylo Ren'},
      {n:'GA-5', name:'Obi-Wan Kenobi'},
      {n:'GA-6', name:'Darth Maul'},
      {n:'GA-7', name:'Chewbacca'},
      {n:'GA-8', name:'BB-8'},
      {n:'GA-9', name:'Jyn Erso'},
      {n:'GA-10', name:'Padmé Amidala'},
      {n:'GA-11', name:'Jod Na Nawood'},
      {n:'GA-12', name:'Boba Fett'},
      {n:'GA-13', name:'Cassian Andor'},
      {n:'GA-14', name:'Grand Admiral Thrawn'},
      {n:'GA-15', name:'General Grievous'},
      {n:'GA-16', name:'Ahsoka Tano'},
      {n:'GA-17', name:'Leia Organa'},
      {n:'GA-18', name:'Count Dooku'},
      {n:'GA-19', name:'Jedi Knight Sol'},
      {n:'GA-20', name:'Yoda'},
      {n:'GA-21', name:'Neel'},
      {n:'GA-22', name:'R2-D2'},
      {n:'GA-23', name:'C-3PO'},
      {n:'GA-24', name:'Jabba The Hutt'},
      {n:'GA-25', name:"Kh'ymm"},
      {n:'GA-26', name:'Director Orson Krennic'},
      {n:'GA-27', name:'Grand Moff Tarkin'},
      {n:'GA-28', name:'Rey'},
      {n:'GA-29', name:'Moff Gideon'},
      {n:'GA-30', name:'Bo-Katan Kryze'},
      {n:'GA-31', name:'Supreme Leader Snoke'},
      {n:'GA-32', name:'Maz Kanata'},
      {n:'GA-33', name:'Finn'},
      {n:'GA-34', name:'Poe Dameron'},
      {n:'GA-35', name:'Krrsantan'},
      {n:'GA-36', name:'Mon Mothma'},
      {n:'GA-37', name:'Luthen Rael'},
      {n:'GA-38', name:'Sabine Wren'},
      {n:'GA-39', name:'Shin Hati'},
      {n:'GA-40', name:'Baylan Skoll'},
      {n:'GA-41', name:'Qui-Gon Jinn'},
      {n:'GA-42', name:'Lando Calrissian'},
      {n:'GA-43', name:'Mace Windu'},
      {n:'GA-44', name:'Emperor Palpatine'},
      {n:'GA-45', name:'The Stranger'},
      {n:'GA-46', name:'Hera Syndulla'},
      {n:'GA-47', name:'Greef Karga'},
      {n:'GA-48', name:'Chopper'},
      {n:'GA-49', name:'Grogu'},
      {n:'GA-50', name:'The Mandalorian'},
    ]
  },

  // ─── INSERTS ─────────────────────────────────────────────────────────────
  {
    id: 'anniv-rots', type: 'insert',
    parallels: [
      { id: 'ins-green',  name: 'Green Refractor',  odds: '1:10',  print_run: 99,   color: '#00e676' },
      { id: 'ins-gold',   name: 'Gold Refractor',   odds: '1:19',  print_run: 50,   color: '#f0c040' },
      { id: 'ins-orange', name: 'Orange Refractor', odds: '1:38',  print_run: 25,   color: '#ff9100' },
      { id: 'ins-black',  name: 'Black Refractor',  odds: '1:93',  print_run: 10,   color: '#616161' },
      { id: 'ins-red',    name: 'Red Refractor',    odds: '1:187', print_run: 5,    color: '#ff1744' },
      { id: 'ins-super',  name: 'Superfractor',     odds: '1:924', print_run: 1,    color: '#ffd700' },
    ], title: '20TH ANNIVERSARY OF REVENGE OF THE SITH — 25 CARDS',
    cards: [
      {n:'ARS-1', name:'Anakin Skywalker'},
      {n:'ARS-2', name:'Obi-Wan Kenobi'},
      {n:'ARS-3', name:'R2-D2'},
      {n:'ARS-4', name:'Super Battle Droid'},
      {n:'ARS-5', name:'Chancellor Palpatine'},
      {n:'ARS-6', name:'Count Dooku'},
      {n:'ARS-7', name:'General Grievous'},
      {n:'ARS-8', name:'Bail Organa'},
      {n:'ARS-9', name:'Padmé Amidala'},
      {n:'ARS-10', name:'C-3PO'},
      {n:'ARS-11', name:'Mace Windu'},
      {n:'ARS-12', name:'Yoda'},
      {n:'ARS-13', name:'Clone Commander Cody'},
      {n:'ARS-14', name:'MagnaGuard'},
      {n:'ARS-15', name:'Ki-Adi-Mundi'},
      {n:'ARS-16', name:'Aayla Secura'},
      {n:'ARS-17', name:'Plo Koon'},
      {n:'ARS-18', name:'Stass Allie'},
      {n:'ARS-19', name:'Chewbacca'},
      {n:'ARS-20', name:'General Tarfful'},
      {n:'ARS-21', name:'Zett Jukassa'},
      {n:'ARS-22', name:'Mas Amedda'},
      {n:'ARS-24', name:'Nute Gunray'},
      {n:'ARS-25', name:'Jar Jar Binks'},
      {n:'ARS-25b', name:'Darth Vader'},
    ]
  },
  {
    id: 'power-of-the-force', type: 'insert',
    parallels: [
      { id: 'ins-blue', name: 'Blue Refractor', print_run: 99, color: '#2979ff' },
      { id: 'ins-gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
      { id: 'magenta-ray-wave', name: 'Magenta Ray Wave Refractor', print_run: 10, color: '#e91e63' },
      { id: 'ins-orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'ins-red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'ins-super', name: 'Superfractor', print_run: 1, color: '#c8d8f0' },
    ], title: 'POWER OF THE FORCE — 25 CARDS',
    cards: [
      {n:'POF-1', name:'Lor San Tekka'},
      {n:'POF-2', name:'Poe Dameron'},
      {n:'POF-3', name:'BB-8'},
      {n:'POF-4', name:'Kylo Ren'},
      {n:'POF-5', name:'General Hux'},
      {n:'POF-6', name:'Stormtrooper'},
      {n:'POF-7', name:'Finn'},
      {n:'POF-8', name:'Captain Phasma'},
      {n:'POF-9', name:'Unkar Plutt'},
      {n:'POF-10', name:'Rey'},
      {n:'POF-11', name:'Tasu Leech'},
      {n:'POF-12', name:'Bala-Tik'},
      {n:'POF-13', name:'Han Solo'},
      {n:'POF-14', name:'Chewbacca'},
      {n:'POF-15', name:'Maz Kanata'},
      {n:'POF-16', name:'Lieutenant Mitaka'},
      {n:'POF-17', name:'Supreme Leader Snoke'},
      {n:'POF-18', name:'Leia Organa'},
      {n:'POF-19', name:'R2-D2'},
      {n:'POF-20', name:'Nien Nunb'},
      {n:'POF-21', name:'Snap Wexley'},
      {n:'POF-22', name:'Ello Asty'},
      {n:'POF-23', name:'Jess Pava'},
      {n:'POF-24', name:'Admiral Statura'},
      {n:'POF-25', name:'Luke Skywalker'},
    ]
  },
  {
    id: 'finest-jedi-knights', type: 'insert',
    parallels: [
      { id: 'ins-green',  name: 'Green Refractor',  odds: '1:10',  print_run: 99,   color: '#00e676' },
      { id: 'ins-gold',   name: 'Gold Refractor',   odds: '1:19',  print_run: 50,   color: '#f0c040' },
      { id: 'ins-orange', name: 'Orange Refractor', odds: '1:38',  print_run: 25,   color: '#ff9100' },
      { id: 'ins-black',  name: 'Black Refractor',  odds: '1:93',  print_run: 10,   color: '#616161' },
      { id: 'ins-red',    name: 'Red Refractor',    odds: '1:187', print_run: 5,    color: '#ff1744' },
      { id: 'ins-super',  name: 'Superfractor',     odds: '1:924', print_run: 1,    color: '#ffd700' },
    ], title: 'FINEST JEDI KNIGHTS — 25 CARDS',
    cards: [
      {n:'FJK-1', name:'Jedi Master Yoda'},
      {n:'FJK-2', name:'Jedi Master Sol'},
      {n:'FJK-3', name:'Jedi Master Vernestra Rwoh'},
      {n:'FJK-4', name:'Jedi Master Indara'},
      {n:'FJK-5', name:'Jedi Padawan Torbin'},
      {n:'FJK-6', name:'Jedi Master Kelnacca'},
      {n:'FJK-7', name:'Jedi Padawan Jecki Lon'},
      {n:'FJK-8', name:'Jedi Padawan Mog Adana'},
      {n:'FJK-9', name:'Jedi Master Ki-Adi-Mundi'},
      {n:'FJK-10', name:'Jedi Padawan Tasi Lowa'},
      {n:'FJK-11', name:'Jedi Knight Yord Fandar'},
      {n:'FJK-12', name:'Jedi Knight Aayla Secura'},
      {n:'FJK-13', name:'Jedi Master Plo Koon'},
      {n:'FJK-14', name:'Jedi Master Mace Windu'},
      {n:'FJK-15', name:'Jedi Master Even Piell'},
      {n:'FJK-16', name:'Jedi Padawan Anakin Skywalker'},
      {n:'FJK-17', name:'Jedi Master Depa Billaba'},
      {n:'FJK-18', name:'Jedi Master Qui-Gon Jinn'},
      {n:'FJK-19', name:'Jedi Master Dooku'},
      {n:'FJK-20', name:'Jedi Master Kelleran Beq'},
      {n:'FJK-21', name:'Jedi Master Shaak Ti'},
      {n:'FJK-22', name:'Jedi Master Kit Fisto'},
      {n:'FJK-23', name:'Jedi Padawan Caleb Dume'},
      {n:'FJK-24', name:'Jedi Master Obi-Wan Kenobi'},
      {n:'FJK-25', name:'Jedi Knight Luke Skywalker'},
    ]
  },
  {
    id: 'stellar-signatures-art-repro', type: 'insert',
    parallels: [
      { id: 'ins-blue-foil', name: 'Blue Foil', print_run: 99, color: '#2979ff' },
      { id: 'ins-gold-foil', name: 'Gold Foil', print_run: 50, color: '#f0c040' },
      { id: 'ins-orange-foil', name: 'Orange Foil', print_run: 25, color: '#ff9100' },
      { id: 'ins-purple-foil', name: 'Purple Foil', print_run: 10, color: '#ce93d8' },
      { id: 'ins-red-foil', name: 'Red Foil', print_run: 5, color: '#ff1744' },
      { id: 'ins-black-foil', name: 'Black Foil', print_run: 1, color: '#616161' },
    ], title: 'STELLAR SIGNATURES ART REPRODUCTION — 100 CARDS',
    cards: [
      {n:'SAS-1', name:'Aayla Secura'},{n:'SAS-2', name:'Agent Kallus'},{n:'SAS-3', name:'Ahsoka Tano'},
      {n:'SAS-4', name:'Anakin Skywalker'},{n:'SAS-5', name:'Asajj Ventress'},{n:'SAS-6', name:'Aurra Sing'},
      {n:'SAS-7', name:'Barriss Offee'},{n:'SAS-8', name:'Baylan Skoll'},{n:'SAS-9', name:'BB-8'},
      {n:'SAS-10', name:'Beezer Fortuna'},{n:'SAS-11', name:'Bix Caleen'},{n:'SAS-12', name:'Bo-Katan Kryze'},
      {n:'SAS-13', name:'Boba Fett'},{n:'SAS-14', name:'Boss Nass'},{n:'SAS-15', name:'Bossk'},
      {n:'SAS-16', name:'C-3PO'},{n:'SAS-17', name:'Cad Bane'},{n:'SAS-18', name:'Captain Phasma'},
      {n:'SAS-19', name:'Cassian Andor'},{n:'SAS-20', name:'Chewbacca'},{n:'SAS-21', name:'Chirrut Îmwe'},
      {n:'SAS-22', name:'Ciddarin Scaleback'},{n:'SAS-23', name:'Cobb Vanth'},{n:'SAS-24', name:'Count Dooku'},
      {n:'SAS-25', name:'Darth Maul'},{n:'SAS-26', name:'Darth Vader'},{n:'SAS-27', name:'Dr. Pershing'},
      {n:'SAS-28', name:'Drash'},{n:'SAS-29', name:'Duchess Satine Kryze'},{n:'SAS-30', name:'Emperor Palpatine'},
      {n:'SAS-31', name:'Ezra Bridger'},{n:'SAS-32', name:'Fennec Shand'},{n:'SAS-33', name:'Fifth Brother'},
      {n:'SAS-34', name:'Finn'},{n:'SAS-35', name:'Garazeb Orrelios'},{n:'SAS-36', name:'General Grievous'},
      {n:'SAS-37', name:'Grand Admiral Thrawn'},{n:'SAS-38', name:'Grand Moff Tarkin'},{n:'SAS-39', name:'Grogu'},
      {n:'SAS-40', name:'Gunter'},{n:'SAS-41', name:'Han Solo'},{n:'SAS-42', name:'Hondo Ohnaka'},
      {n:'SAS-43', name:'IG-12'},{n:'SAS-44', name:'Jango Fett'},{n:'SAS-45', name:'Jar Jar Binks'},
      {n:'SAS-46', name:'Jecki Lon'},{n:'SAS-47', name:'Jod Na Nawood'},{n:'SAS-48', name:'Kanan Jarrus'},
      {n:'SAS-49', name:'Kelnacca'},{n:'SAS-50', name:'Kino Loy'},{n:'SAS-51', name:'Kit Fisto'},
      {n:'SAS-52', name:'Koska Reeves'},{n:'SAS-53', name:'Krrsantan'},{n:'SAS-54', name:'Kuiil'},
      {n:'SAS-55', name:'Kylo Ren'},{n:'SAS-56', name:'Lando Calrissian'},{n:'SAS-57', name:'Leia Organa'},
      {n:'SAS-58', name:'Luke Skywalker'},{n:'SAS-59', name:'Luminara Unduli'},{n:'SAS-60', name:'Mace Windu'},
      {n:'SAS-61', name:'Marrok'},{n:'SAS-62', name:'Master Indara'},{n:'SAS-63', name:'Master Torbin'},
      {n:'SAS-64', name:'Max Rebo'},{n:'SAS-65', name:'Mayor Mok Shaiz'},{n:'SAS-66', name:'Maz Kanata'},
      {n:'SAS-67', name:'Moff Gideon'},{n:'SAS-68', name:'Mon Mothma'},{n:'SAS-69', name:'NED-B'},
      {n:'SAS-70', name:'Neel'},{n:'SAS-71', name:'Obi-Wan Kenobi'},{n:'SAS-72', name:'Omega'},
      {n:'SAS-73', name:'Padmé Amidala'},{n:'SAS-74', name:'Paz Vizsla'},{n:'SAS-75', name:'Poe Dameron'},
      {n:'SAS-76', name:'Pong Krell'},{n:'SAS-77', name:"Qi'ra"},{n:'SAS-78', name:'R2-D2'},
      {n:'SAS-79', name:'Rey'},{n:'SAS-80', name:'Sabine Wren'},{n:'SAS-81', name:'Savage Opress'},
      {n:'SAS-82', name:'Sergeant Mosk'},{n:'SAS-83', name:'Seventh Sister'},{n:'SAS-84', name:'Shaak Ti'},
      {n:'SAS-85', name:'Shin Hati'},{n:'SAS-86', name:'Sidon Ithano'},{n:'SAS-87', name:'SM-33'},
      {n:'SAS-88', name:'Sol'},{n:'SAS-89', name:'Stormtrooper'},{n:'SAS-90', name:'Supreme Leader Snoke'},
      {n:'SAS-91', name:'The Armorer'},{n:'SAS-92', name:'The Grand Inquisitor'},{n:'SAS-93', name:'The Mandalorian and Grogu'},
      {n:'SAS-94', name:'The Stranger'},{n:'SAS-95', name:'Vect Nokru'},{n:'SAS-96', name:'Vel Sartha'},
      {n:'SAS-97', name:'Vernestra Rwoh'},{n:'SAS-98', name:'Yoda'},{n:'SAS-99', name:'Zam Wessell'},
      {n:'SAS-100', name:'Zorii Bliss'},
    ]
  },
  {
    id: 'galactic-funk', type: 'insert',
    parallels: [
      { id: 'ins-gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
      { id: 'ins-orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'ins-black', name: 'Black Refractor', print_run: 10, color: '#616161' },
      { id: 'ins-red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'ins-super', name: 'Superfractor', print_run: 1, color: '#c8d8f0' },
    ], title: 'GALACTIC FUNK — 15 CARDS',
    cards: [
      {n:'GF-1', name:'Max Rebo'},{n:'GF-2', name:'Droopy McCool'},{n:'GF-3', name:'Sy Snootles'},
      {n:'GF-4', name:'Joh Yowza'},{n:'GF-5', name:'Ak-Rev'},{n:'GF-6', name:'Umpass-Stay'},
      {n:'GF-7', name:'Doda Bodonawieedo'},{n:'GF-8', name:"Figrin D'an"},{n:'GF-9', name:"Doikk Na'ts"},
      {n:'GF-10', name:"Ickabel G'ont"},{n:'GF-11', name:"Tech Mo'r"},{n:'GF-12', name:'Taybin Ralorsa'},
      {n:'GF-13', name:'Infrablue Zedbeddy Coggins'},{n:'GF-14', name:'Sudswater Dillifay Glon'},
      {n:'GF-15', name:'Ubert Quaril'},
    ]
  },
  {
    id: 'cortosis-metal', type: 'insert',
    parallels: [
      { id: 'ins-purple-foil', name: 'Purple Foil', print_run: 50, color: '#ce93d8' },
      { id: 'ins-orange-foil', name: 'Orange Foil', print_run: 25, color: '#ff9100' },
      { id: 'ins-red-foil', name: 'Red Foil', print_run: 10, color: '#ff1744' },
      { id: 'ins-black-foil', name: 'Black Foil', print_run: 5, color: '#616161' },
      { id: 'ins-hyperspace-foil', name: 'Hyperspace Foil', print_run: 1, color: '#80d8ff' },
    ], title: 'CORTOSIS METAL — 20 CARDS',
    cards: [
      {n:'C-1', name:'Ahsoka Tano'},{n:'C-2', name:'Grand Admiral Thrawn'},{n:'C-3', name:'Han Solo'},
      {n:'C-4', name:'The Stranger'},{n:'C-5', name:'Kylo Ren'},{n:'C-6', name:'Leia Organa'},
      {n:'C-7', name:'Luke Skywalker'},{n:'C-8', name:'Mace Windu'},{n:'C-9', name:'Obi-Wan Kenobi'},
      {n:'C-10', name:'R2-D2'},{n:'C-11', name:'The Mandalorian'},{n:'C-12', name:'Anakin Skywalker'},
      {n:'C-13', name:'Yoda'},{n:'C-14', name:'Boba Fett'},{n:'C-15', name:'C-3PO'},
      {n:'C-16', name:'Chewbacca'},{n:'C-17', name:'Count Dooku'},{n:'C-18', name:'Darth Maul'},
      {n:'C-19', name:'Darth Vader'},{n:'C-20', name:'Darth Sidious'},
    ]
  },
  {
    id: 'droid-shadowbox', type: 'insert',
    parallels: [
      { id: 'ins-gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
      { id: 'ins-orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'magenta-ray-wave', name: 'Magenta Ray Wave Refractor', print_run: 10, color: '#e91e63' },
      { id: 'ins-red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'ins-super', name: 'Superfractor', print_run: 1, color: '#c8d8f0' },
    ], title: 'DROID SHADOWBOX — 20 CARDS',
    cards: [
      {n:'DS-1', name:'BD-1'},{n:'DS-2', name:'R2-D2'},{n:'DS-3', name:'C-3PO'},
      {n:'DS-4', name:'R5-D4'},{n:'DS-5', name:'Chopper'},{n:'DS-6', name:'Huyang'},
      {n:'DS-7', name:'MagnaGuard'},{n:'DS-8', name:'BB-8'},{n:'DS-9', name:'BB-9E'},
      {n:'DS-10', name:'D-O'},{n:'DS-11', name:'IG-11'},{n:'DS-12', name:'Vulture Droid'},
      {n:'DS-13', name:'Super Battle Droid'},{n:'DS-14', name:'HK-87'},{n:'DS-15', name:'Droideka'},
      {n:'DS-16', name:'K-2SO'},{n:'DS-17', name:'2-1B'},{n:'DS-18', name:'B2EMO'},
      {n:'DS-19', name:'Battle Droid'},{n:'DS-20', name:'C2-B5'},
    ]
  },
  {
    id: 'lightsaber-shadowbox', type: 'insert',
    parallels: [
      { id: 'ins-green',  name: 'Green Refractor',  odds: '1:10',  print_run: 99,   color: '#00e676' },
      { id: 'ins-gold',   name: 'Gold Refractor',   odds: '1:19',  print_run: 50,   color: '#f0c040' },
      { id: 'ins-orange', name: 'Orange Refractor', odds: '1:38',  print_run: 25,   color: '#ff9100' },
      { id: 'ins-black',  name: 'Black Refractor',  odds: '1:93',  print_run: 10,   color: '#616161' },
      { id: 'ins-red',    name: 'Red Refractor',    odds: '1:187', print_run: 5,    color: '#ff1744' },
      { id: 'ins-super',  name: 'Superfractor',     odds: '1:924', print_run: 1,    color: '#ffd700' },
    ], title: 'LIGHTSABER SHADOWBOX — 20 CARDS',
    cards: [
      {n:'SAB-1', name:'Qui-Gon Jinn'},{n:'SAB-2', name:'Obi-Wan Kenobi'},{n:'SAB-3', name:'Darth Maul'},
      {n:'SAB-4', name:'Mace Windu'},{n:'SAB-5', name:'Anakin Skywalker'},{n:'SAB-6', name:'Jedi Master Dooku'},
      {n:'SAB-7', name:'Count Dooku'},{n:'SAB-8', name:'Yoda'},{n:'SAB-9', name:'Darth Sidious'},
      {n:'SAB-10', name:'Darth Vader'},{n:'SAB-11', name:'Luke Skywalker'},{n:'SAB-12', name:'Rey'},
      {n:'SAB-13', name:'Kylo Ren'},{n:'SAB-14', name:'Ahsoka Tano'},{n:'SAB-15', name:'Baylan Skoll'},
      {n:'SAB-16', name:'Shin Hati'},{n:'SAB-17', name:'Asajj Ventress'},{n:'SAB-18', name:'Yord Fandar'},
      {n:'SAB-19', name:'The Mandalorian'},{n:'SAB-20', name:'Cal Kestis'},
    ]
  },
  {
    id: 'civilized-age-art', type: 'insert',
    parallels: [
      { id: 'ins-kaleidoscope', name: 'Kaleidoscope Refractor', print_run: 25, color: '#b388ff' },
      { id: 'ins-shimmer', name: 'Shimmer Refractor', print_run: 10, color: '#b2ebf2' },
      { id: 'ins-ray-wave', name: 'Ray Wave Refractor', print_run: 5, color: '#ff8a80' },
      { id: 'ins-super', name: 'Superfractor', print_run: 1, color: '#c8d8f0' },
    ], title: 'CIVILIZED AGE ART — 10 CARDS',
    cards: [
      {n:'CIV-1', name:'Darth Vader'},{n:'CIV-2', name:'Ahsoka Tano'},{n:'CIV-3', name:'BB-8'},
      {n:'CIV-4', name:'Maz Kanata'},{n:'CIV-5', name:'Darth Maul'},{n:'CIV-6', name:'Neel'},
      {n:'CIV-7', name:'Padmé Amidala'},{n:'CIV-8', name:'Chewbacca'},{n:'CIV-9', name:'C-3PO'},
      {n:'CIV-10', name:'General Grievous'},
    ]
  },

  // ─── AUTOGRAPHS ───────────────────────────────────────────────────────────
  {
    id: 'chrome-black-auto', type: 'auto',
    parallels: [
      { id: 'auto-blue-red-lava', name: 'Blue/Red Lava Refractor', odds: '1:13',  print_run: 99,   color: '#4fc3f7' },
      { id: 'auto-gold',          name: 'Gold Refractor',          odds: '1:26',  print_run: 50,   color: '#f0c040' },
      { id: 'auto-orange',        name: 'Orange Refractor',        odds: '1:46',  print_run: 25,   color: '#ff9100' },
      { id: 'auto-magenta',       name: 'Magenta Ray Wave Refractor',        odds: '1:78',  print_run: 10,   color: '#e91e63' },
      { id: 'auto-red',           name: 'Red Refractor',           odds: '1:94',  print_run: 5,    color: '#ff1744' },
      { id: 'auto-plate-cyan',    name: 'Printing Plate Cyan',     odds: '1:172', print_run: 1,    color: '#00e5ff' },
      { id: 'auto-plate-magenta', name: 'Printing Plate Magenta',  odds: '1:172', print_run: 1,    color: '#e91e63' },
      { id: 'auto-plate-yellow',  name: 'Printing Plate Yellow',   odds: '1:172', print_run: 1,    color: '#ffee58' },
      { id: 'auto-plate-black',   name: 'Printing Plate Black',    odds: '1:172', print_run: 1,    color: '#616161' },
      { id: 'auto-super',         name: 'Superfractor',            odds: '1:442', print_run: 1,    color: '#ffd700' },
    ], title: 'CHROME BLACK AUTOGRAPH',
    cards: [
      {n:'CA-TMO', name:'General Parnadee (Tanya Moodie)'},
      {n:'CB-AA', name:'Bix Caleen (Adria Arjona)'},
      {n:'CB-AB', name:'Kelleran Beq (Ahmed Best)'},
      {n:'CB-AD', name:'Kylo Ren (Adam Driver)'},
      {n:'CB-AK', name:'Jecki Lon (Dafne Keen)'},
      {n:'CB-AS', name:'Supreme Leader Snoke (Andy Serkis)'},
      {n:'CB-CHEW', name:'Chewbacca (Peter Mayhew)'},
      {n:'CB-CL', name:'Commissioner Helgait (Christopher Lloyd)'},
      {n:'CB-COO', name:'Ochi of Bestoon (Liam Cook)'},
      {n:'CB-DB', name:'Jabba The Hutt (David Barclay)'},
      {n:'CB-DG', name:'Dedra Meero (Denise Gough)'},
      {n:'CB-DK', name:'Cad Bane (Dorian Kingi)'},
      {n:'CB-DL', name:'Morgan Elsbeth (Diana Lee Inosanto)'},
      {n:'CB-DP', name:'Darth Vader (David Prowse)'},
      {n:'CB-EK', name:'Enfys Nest (Erin Kellyman)'},
      {n:'CB-EM', name:'The Armorer (Emily Swallow)'},
      {n:'CB-ES', name:'Barriss Offee (Meredith Salenger)'},
      {n:'CB-FJ', name:'Jyn Erso (Felicity Jones)'},
      {n:'CB-FP', name:'Kanan Jarrus (Freddie Prinze Jr.)'},
      {n:'CB-GE', name:'Moff Gideon (Giancarlo Esposito)'},
      {n:'CB-GH', name:'Grand Moff Tarkin (Guy Henry)'},
      {n:'CB-HC', name:'Anakin Skywalker (Hayden Christensen)'},
      {n:'CB-HF', name:'Han Solo (Harrison Ford)'},
      {n:'CB-IM', name:'Darth Sidious (Ian McDiarmid)'},
      {n:'CB-JE', name:'Owen Lars (Joel Edgerton)'},
      {n:'CB-KR', name:'Zorii Bliss (Keri Russell)'},
      {n:'CB-LRB', name:'D-O (Lynn Robertson Bruce)'},
      {n:'CB-LW', name:'Zam Wesell (Leanna Walsman)'},
      {n:'CB-MH', name:'Luke Skywalker (Mark Hamill)'},
      {n:'CB-MJ', name:'The Stranger (Manny Jacinto)'},
      {n:'CB-NF', name:'Asajj Ventress (Nika Futterman)'},
      {n:'CB-NL', name:'Sabine Wren (Natasha Liu Bordizzo)'},
      {n:'CB-NP', name:'Padmé Amidala (Natalie Portman)'},
      {n:'CB-NS', name:'Watto (Andy Secombe)'},
      {n:'CB-OI', name:'Poe Dameron (Oscar Isaac)'},
      {n:'CB-OJ', name:'Kawlan Roken (O\'Shea Jackson)'},
      {n:'CB-PB', name:'Dryden Vos (Paul Bettany)'},
      {n:'CB-PD', name:'Marrok (Paul Darnell)'},
      {n:'CB-PK', name:'Edrio Two Tubes (Paul Kasey)'},
      {n:'CB-PL', name:'Kit Fisto (Phil LaMarr)'},
      {n:'CB-PP', name:'The Mandalorian (Pedro Pascal)'},
      {n:'CB-RP', name:'Darth Maul (Ray Park)'},
      {n:'CB-RUS', name:'Plo Koon (Alan Ruscoe)'},
      {n:'CB-SL', name:'Mace Windu (Samuel L. Jackson)'},
      {n:'CB-SS', name:'Luthen Rael (Stellan Skarsgård)'},
      {n:'CB-TF', name:'Paz Vizsla (Tait Fletcher)'},
      {n:'CB-TM', name:'Boba Fett (Temuera Morrison)'},
      {n:'CB-TR', name:'Admiral Ackbar (Tim Rose)'},
      {n:'CB-TW', name:'IG-12 (Taika Waititi)'},
      {n:'CB-WD', name:'Wicket W. Warrick (Warwick Davis)'},
      {n:'CB-XJ', name:'Tusken Raider (Xavier Jimenez)'},
    ]
  },
  {
    id: 'finest-auto', type: 'auto',
    parallels: [
      { id: 'auto-aqua-mini-diamond', name: 'Aqua Mini-Diamond Refractor', print_run: 150, color: '#00e5ff' },
      { id: 'auto-blue-red-lava', name: 'Blue/Red Lava Refractor', print_run: null, color: '#ff5252' },
      { id: 'auto-green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
      { id: 'auto-purple-lazer', name: 'Purple Lazer Refractor', print_run: 75, color: '#ce93d8' },
      { id: 'auto-gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
      { id: 'auto-orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
      { id: 'auto-black-ray-wave', name: 'Black Ray Wave Refractor', print_run: 10, color: '#424242' },
      { id: 'auto-red-wave', name: 'Red Wave Refractor', print_run: 5, color: '#ff1744' },
      { id: 'auto-red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'auto-plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-black', name: 'Printing Plate Black', print_run: 1, color: '#616161' },
      { id: 'auto-super', name: 'Superfractor', print_run: 1, color: '#c8d8f0' },
    ], title: 'FINEST AUTOGRAPH',
    cards: [
      {n:'FA-AA', name:'Aayla Secura (Amy Allen)'},
      {n:'FA-AB', name:'Jar Jar Binks (Ahmed Best)'},
      {n:'FA-AL', name:'Major Partagaz (Anton Lesser)'},
      {n:'FA-ANT', name:'Kassa (Antonio Viña)'},
      {n:'FA-AWO', name:'General Grievous (Matthew Wood)'},
      {n:'FA-C3', name:'C-3PO (Anthony Daniels)'},
      {n:'FA-CB', name:'Yord Fandar (Charlie Barnett)'},
      {n:'FA-DAV', name:'B2EM0 (Dave Chapman)'},
      {n:'FA-DG', name:'General Hux (Domhnall Gleeson)'},
      {n:'FA-DL', name:'Cassian Andor (Diego Luna)'},
      {n:'FA-DP', name:'Sergeant Melshi (Duncan Pow)'},
      {n:'FA-DR', name:'Rey (Daisy Ridley)'},
      {n:'FA-EC', name:"Qi'ra (Emilia Clarke)"},
      {n:'FA-EM', name:'Obi-Wan Kenobi (Ewan McGregor)'},
      {n:'FA-FOR', name:'Han Solo (Harrison Ford)'},
      {n:'FA-FW', name:'Saw Gerrera (Forest Whitaker)'},
      {n:'FA-GO', name:'Mon Mothma (Genevieve O\'Reilly)'},
      {n:'FA-HAM', name:'Luke Skywalker (Mark Hamill)'},
      {n:'FA-HAY', name:'Anakin Skywalker (Hayden Christensen)'},
      {n:'FA-IS', name:'Shin Hati (Ivanna Sakhno)'},
      {n:'FA-JB', name:'Finn (John Boyega)'},
      {n:'FA-JG', name:'General Maximilian Veers (Julian Glover)'},
      {n:'FA-JSU', name:'Jedi Master Kelnacca (Joonas Suotamo)'},
      {n:'FA-KEL', name:'Bistan (Nick Kellington)'},
      {n:'FA-KM', name:'Rose Tico (Kelly Marie Tran)'},
      {n:'FA-KS', name:'Syril Karn (Kyle Soller)'},
      {n:'FA-LAW', name:'Jod Na Nawood (Jude Law)'},
      {n:'FA-LEM', name:'Sebulba (Lewis MacLeod)'},
      {n:'FA-LJ', name:'Jedi Master Sol (Lee Jung-jae)'},
      {n:'FA-LNY', name:'Maz Kanata (Lupita Nyong\'o)'},
      {n:'FA-MEW', name:'Hera Syndulla (Mary Elizabeth Winstead)'},
      {n:'FA-MM', name:'Galen Erso (Mads Mikkelsen)'},
      {n:'FA-MQ', name:'Nien Nunb (Mike Quinn)'},
      {n:'FA-MS', name:'Peli Motto (Amy Sedaris)'},
      {n:'FA-MW', name:'Fennec Shand (Ming-Na Wen)'},
      {n:'FA-NAT', name:'Padmé Amidala (Natalie Portman)'},
      {n:'FA-OFD', name:'Sio Bibble (Oliver Ford Davies)'},
      {n:'FA-OS', name:'Shaak Ti (Orli Shoshan)'},
      {n:'FA-PB', name:'Greedo (Paul Blake)'},
      {n:'FA-PS', name:'Carson Teva (Paul Sun-Hyung Lee)'},
      {n:'FA-RD', name:'Ahsoka Tano (Rosario Dawson)'},
      {n:'FA-SAM', name:'Mace Windu (Samuel L. Jackson)'},
      {n:'FA-SB', name:'Garazeb Orrelios (Steve Blum)'},
      {n:'FA-SM', name:'The Seventh Sister (Sarah Michelle Gellar)'},
      {n:'FA-SW', name:'Max Rebo (Simon Williamson)'},
      {n:'FA-SWA', name:'Kerri (Belle Swarc)'},
      {n:'FA-THU', name:'The Modifier (Thundercat)'},
      {n:'FA-TO', name:'Cobb Vanth (Timothy Olyphant)'},
      {n:'FA-WEH', name:'The Client (Werner Herzog)'},
    ]
  },
  {
    id: 'stellar-sig-auto', type: 'auto',
    parallels: [
      { id: 'auto-stellar-green', name: 'Green', print_run: 99, color: '#00e676' },
      { id: 'auto-stellar-blue', name: 'Blue', print_run: 25, color: '#2979ff' },
      { id: 'auto-stellar-purple', name: 'Purple', print_run: 10, color: '#ce93d8' },
      { id: 'auto-stellar-gold', name: 'Gold', print_run: 5, color: '#f0c040' },
      { id: 'auto-galactic-black', name: 'Galactic Black', print_run: 1, color: '#212121' },
      { id: 'auto-imperial-red', name: 'Imperial Red', print_run: 1, color: '#b71c1c' },
      { id: 'auto-rebel-orange', name: 'Rebel Alliance Orange', print_run: 1, color: '#ff6f00' },
    ], title: 'STELLAR SIGNATURES AUTOGRAPH',
    cards: [
      {n:'SSA-AB', name:'Jar Jar Binks (Ahmed Best)'},
      {n:'SSA-ALA', name:'Perrin Fertha (Alastair Mackenzie)'},
      {n:'SSA-AMY', name:'Aayla Secura (Amy Allen)'},
      {n:'SSA-ANN', name:'Bazine Netal (Anna Brewster)'},
      {n:'SSA-AS', name:'Supreme Leader Snoke (Andy Serkis)'},
      {n:'SSA-BAR', name:'Queen Miraj Scintel (Rajia Baroudi)'},
      {n:'SSA-BRO', name:'Leida Mothma (Bronte Carmichael)'},
      {n:'SSA-BW', name:'Lando Calrissian (Billy Dee Williams)'},
      {n:'SSA-CA', name:'Jedi Master Indara (Carrie-Anne Moss)'},
      {n:'SSA-DC', name:'BB-8 (Dave Chapman)'},
      {n:'SSA-DG', name:'Dedra Meero (Denise Gough)'},
      {n:'SSA-DI', name:'Cassian Andor (Diego Luna)'},
      {n:'SSA-DKE', name:'General Engell (Diana Kent)'},
      {n:'SSA-DL', name:'Wedge Antilles (Denis Lawson)'},
      {n:'SSA-DR', name:'Rey (Daisy Ridley)'},
      {n:'SSA-FIO', name:'Maarva (Fiona Shaw)'},
      {n:'SSA-FJ', name:'Jyn Erso (Felicity Jones)'},
      {n:'SSA-GC', name:'Captain Phasma (Gwendoline Christie)'},
      {n:'SSA-GE', name:'Moff Gideon (Giancarlo Esposito)'},
      {n:'SSA-GH', name:'Grand Moff Tarkin (Guy Henry)'},
      {n:'SSA-GIN', name:'Ketsu Onyo (Gina Torres)'},
      {n:'SSA-GL', name:'General Hux (Domhnall Gleeson)'},
      {n:'SSA-HF', name:'Han Solo (Harrison Ford)'},
      {n:'SSA-IM', name:'Darth Sidious (Ian McDiarmid)'},
      {n:'SSA-IS', name:'Shin Hati (Ivanna Sakhno)'},
      {n:'SSA-JAC', name:'The Stranger (Manny Jacinto)'},
      {n:'SSA-JOP', name:'Brasso (Joplin Sibtain)'},
      {n:'SSA-JS', name:'Chewbacca (Joonas Suotamo)'},
      {n:'SSA-KEL', name:'Bistan (Nick Kellington)'},
      {n:'SSA-KK', name:'Sabé (Keira Knightley)'},
      {n:'SSA-KOW', name:'Camie (Mandy Kowalski)'},
      {n:'SSA-KS', name:'Bo-Katan Kryze (Katee Sackhoff)'},
      {n:'SSA-LAW', name:'Jod Na Nawood (Jude Law)'},
      {n:'SSA-LIZ', name:'The Duchess (Lizzo)'},
      {n:'SSA-LJj', name:'Jedi Master Sol (Lee Jung-jae)'},
      {n:'SSA-LM', name:'Grand Admiral Thrawn (Lars Mikkelsen)'},
      {n:'SSA-MH', name:'Luke Skywalker (Mark Hamill)'},
      {n:'SSA-MW', name:'Hera Syndulla (Mary Elizabeth Winstead)'},
      {n:'SSA-NAZ', name:'Synara San (Nazneen Contractor)'},
      {n:'SSA-NB', name:'Sabine Wren (Natasha Liu Bordizzo)'},
      {n:'SSA-OS', name:'Shaak Ti (Orli Shoshan)'},
      {n:'SSA-RA', name:'Bodhi Rook (Riz Ahmed)'},
      {n:'SSA-RCC', name:'Wim (Ravi Cabot-Conyers)'},
      {n:'SSA-RD', name:'Ahsoka Tano (Rosario Dawson)'},
      {n:'SSA-RF', name:'The Grand Inquisitor (Rupert Friend)'},
      {n:'SSA-RUS', name:'Plo Koon (Alan Ruscoe)'},
      {n:'SSA-SS', name:'Luthen Rael (Stellan Skarsgård)'},
      {n:'SSA-TAN', name:'General Parnadee (Tanya Moodie)'},
      {n:'SSA-TM', name:'Boba Fett (Temuera Morrison)'},
      {n:'SSA-TW', name:'IG-11 (Taika Waititi)'},
      {n:'SSA-VAN', name:'Hera Syndulla (Vanessa Marshall)'},
      {n:'SSA-WE', name:'Fennec Shand (Ming-Na Wen)'},
      {n:'SSA-WHY', name:'Vetch (Ian Whyte)'},
      {n:'SSA-WO', name:'General Grievous (Matthew Wood)'},
    ]
  },
  {
    id: 'cortosis-metal-auto', type: 'auto',
    parallels: [
      { id: 'auto-purple-foil', name: 'Purple Foil', print_run: 50, color: '#ce93d8' },
      { id: 'auto-orange-foil', name: 'Orange Foil', print_run: 25, color: '#ff9100' },
      { id: 'auto-red-foil', name: 'Red Foil', print_run: 10, color: '#ff1744' },
      { id: 'auto-black-foil', name: 'Black Foil', print_run: 5, color: '#616161' },
      { id: 'auto-hyperspace-foil', name: 'Hyperspace Foil', print_run: 1, color: '#80d8ff' },
    ], title: 'CORTOSIS METAL AUTOGRAPH',
    cards: [
      {n:'CM-AB', name:'Kelleran Beq (Ahmed Best)'},
      {n:'CM-DAR', name:'Marrok (Paul Darnell)'},
      {n:'CM-DEE', name:'Clone Captain Rex (Dee Bradley Baker)'},
      {n:'CM-KS', name:'Bo-Katan Kryze (Katee Sackhoff)'},
      {n:'CM-LJ', name:'Sol (Lee Jung-jae)'},
      {n:'CM-LM', name:'Grand Admiral Thrawn (Lars Mikkelsen)'},
      {n:'CM-MJ', name:'The Stranger (Manny Jacinto)'},
      {n:'CM-NB', name:'Sabine Wren (Natasha Liu Bordizzo)'},
      {n:'CM-RD', name:'Ahsoka Tano (Rosario Dawson)'},
      {n:'CM-SW', name:'Maul (Sam Witwer)'},
      {n:'CM-TM', name:'Boba Fett (Temuera Morrison)'},
    ]
  },
  {
    id: 'trio-auto', type: 'auto',
    parallels: [
      { id: 'auto-silver-frame', name: 'Silver Frame', print_run: 5, color: '#bdbdbd' },
      { id: 'auto-gold-frame', name: 'Gold Frame', print_run: 1, color: '#f0c040' },
      { id: 'auto-plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-black', name: 'Printing Plate Black', print_run: 1, color: '#616161' },
    ], title: 'TRIO AUTOGRAPH',
    cards: [
      {n:'TA-DOJ', name:'Finn / Poe Dameron / Rey (Boyega, Isaac, Ridley)'},
      {n:'TA-HBJ', name:'Han Solo / Lando / Chewbacca (Ford, Williams, Mayhew)'},
      {n:'TA-HEN', name:'Obi-Wan / Padmé / Anakin (McGregor, Portman, Christensen)'},
      {n:'TA-HIS', name:'Darth Sidious / Anakin / Mace Windu (McDiarmid, Christensen, Jackson)'},
      {n:'TA-MRP', name:'The Mandalorian / Ahsoka / Luke (Pascal, Dawson, Hamill)'},
      {n:'TA-REP', name:"Qi'ra / Maul / Dryden Vos (Clarke, Park, Bettany)"},
      {n:'TA-RNM', name:'Hera / Sabine / Ahsoka (Winstead, Liu Bordizzo, Dawson)'},
      {n:'TA-TMP', name:'The Mandalorian / Boba Fett / Fennec (Pascal, Morrison, Wen)'},
    ]
  },
  {
    id: 'quad-auto', type: 'auto',
    parallels: [
      { id: 'auto-silver-frame', name: 'Silver Frame', print_run: 5, color: '#bdbdbd' },
      { id: 'auto-gold-frame', name: 'Gold Frame', print_run: 1, color: '#f0c040' },
      { id: 'auto-plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#c8d8f0' },
      { id: 'auto-plate-black', name: 'Printing Plate Black', print_run: 1, color: '#616161' },
    ], title: 'QUAD AUTOGRAPH',
    cards: [
      {n:'QA-ADJP', name:'Kylo Ren / Finn / Poe / Rey (Driver, Boyega, Isaac, Ridley)'},
      {n:'QA-DAGA', name:'Kylo Ren / Hux / Snoke / Phasma (Driver, Gleeson, Serkis, Christie)'},
      {n:'QA-DGSF', name:'Saw / Luthen / Mon Mothma / Cassian (Whitaker, Skarsgård, O\'Reilly, Luna)'},
      {n:'QA-HNSE', name:'Padmé / Mace / Obi-Wan / Anakin (Portman, Jackson, McGregor, Christensen)'},
      {n:'QA-MERN', name:'Hera / Ahsoka / Ezra / Sabine (Winstead, Dawson, Esfandi, Liu Bordizzo)'},
      {n:'QA-PKGE', name:'Bo-Katan / Armorer / Mandalorian / Moff (Sackhoff, Swallow, Pascal, Esposito)'},
      {n:'QA-TDMC', name:'Boba Fett / Cad Bane / Krrsantan / Fennec (Morrison, Kingi, Jones, Wen)'},
    ]
  },
  {
    id: 'light-side-ultimate', type: 'auto',
    parallels: [], title: 'LIGHT SIDE ULTIMATE AUTOGRAPH BOOK CARD',
    cards: [
      {n:'LSU-BC', name:'20-Signer Light Side Book (Portman, Christensen, Ridley, Isaac, McGregor, Jackson, Fisher, Ford, Hamill, Nyong\'o, Daniels, Jones, Prinze Jr., O\'Reilly, Luna, Esfandi, Pascal, Sackhoff, Dawson, Mayhew)'},
    ]
  },
  {
    id: 'dark-side-ultimate', type: 'auto',
    parallels: [], title: 'DARK SIDE ULTIMATE AUTOGRAPH BOOK CARD',
    cards: [
      {n:'DSU-BC', name:'20-Signer Dark Side Book (Mikkelsen, Herzog, Friend, Ingram, Henry, Lesser, Serkis, Gleeson, Christie, Kihlstedt, Gellar, Takei, Curry, Witwer, Futterman, McDiarmid, Christensen, Wood, Park, Driver)'},
    ]
  },

  // ─── SKETCH CARDS ─────────────────────────────────────────────────────────
  {
    id: 'sketchagraphs', type: 'sketch', title: 'SKETCHAGRAPHS',
    cards: [
      {n:'SCA-AAJ', name:'Bix Caleen (Adria Arjona)'},
      {n:'SCA-ABE', name:'Jar Jar Binks (Ahmed Best)'},
      {n:'SCA-BDW', name:'Lando Calrissian (Billy Dee Williams)'},
      {n:'SCA-CAM', name:'Indara (Carrie-Anne Moss)'},
      {n:'SCA-DGO', name:'Dedra Meero (Denise Gough)'},
      {n:'SCA-EMC', name:"Qi'ra (Emilia Clarke)"},
      {n:'SCA-FEJ', name:'Jyn Erso (Felicity Jones)'},
      {n:'SCA-FORD', name:'Han Solo (Harrison Ford)'},
      {n:'SCA-FRI', name:'The Grand Inquisitor (Rupert Friend)'},
      {n:'SCA-GE', name:'Moff Gideon (Giancarlo Esposito)'},
      {n:'SCA-GOR', name:"Mon Mothma (Genevieve O'Reilly)"},
      {n:'SCA-IM', name:'Emperor Palpatine (Ian McDiarmid)'},
      {n:'SCA-JAL', name:'Gunter (Jaleel White)'},
      {n:'SCA-KKR', name:'KB (Kyriana Kratter)'},
      {n:'SCA-KKY', name:'Sabé (Keira Knightley)'},
      {n:'SCA-KS', name:'Bo-Katan Kryze (Katee Sackhoff)'},
      {n:'SCA-LAW', name:'Jod Na Nawood (Jude Law)'},
      {n:'SCA-LJj', name:'Sol (Lee Jung-jae)'},
      {n:'SCA-LM', name:'Grand Admiral Thrawn (Lars Mikkelsen)'},
      {n:'SCA-MAH', name:'Luke Skywalker (Mark Hamill)'},
      {n:'SCA-MEW', name:'Hera Syndulla (Mary Elizabeth Winstead)'},
      {n:'SCA-MJ', name:'The Stranger (Manny Jacinto)'},
      {n:'SCA-MNW', name:'Fennec Shand (Ming-Na Wen)'},
      {n:'SCA-NF', name:'Asajj Ventress (Nika Futterman)'},
      {n:'SCA-NLB', name:'Sabine Wren (Natasha Liu Bordizzo)'},
      {n:'SCA-PEG', name:'Unkar Plutt (Simon Pegg)'},
      {n:'SCA-RCC', name:'Wim (Ravi Cabot-Conyers)'},
      {n:'SCA-RD', name:'Ahsoka Tano (Rosario Dawson)'},
      {n:'SCA-SED', name:'Peli Motto (Amy Sedaris)'},
      {n:'SCA-SKA', name:'Luthen Rael (Stellan Skarsgård)'},
      {n:'SCA-SOL', name:'Syril Karn (Kyle Soller)'},
      {n:'SCA-TAT', name:'Brutus (Fred Tatasciore)'},
      {n:'SCA-TM', name:'Boba Fett (Temuera Morrison)'},
      {n:'SCA-TR', name:'Admiral Ackbar (Tim Rose)'},
      {n:'SCA-WAI', name:'IG-11 (Taika Waititi)'},
      {n:'SCA-WES', name:'Captain Enoch (Wes Chatham)'},
      {n:'SCA-WHI', name:'Saw Gerrera (Forest Whitaker)'},
      {n:'SCA-WIL', name:'Max Rebo (Simon Williamson)'},
      {n:'SCA-WOO', name:'General Grievous (Matthew Wood)'},
    ]
  },
  {
    id: 'stellar-sig-art-cards', type: 'sketch', title: 'STELLAR SIGNATURES ART CARDS — 100 CARDS',
    cards: [
      {n:'SA-1', name:'Aayla Secura'},{n:'SA-2', name:'Agent Kallus'},{n:'SA-3', name:'Ahsoka Tano'},
      {n:'SA-4', name:'Anakin Skywalker'},{n:'SA-5', name:'Asajj Ventress'},{n:'SA-6', name:'Aurra Sing'},
      {n:'SA-7', name:'Barriss Offee'},{n:'SA-8', name:'Baylan Skoll'},{n:'SA-9', name:'BB-8'},
      {n:'SA-10', name:'Beezer Fortuna'},{n:'SA-11', name:'Bix Caleen'},{n:'SA-12', name:'Bo-Katan Kryze'},
      {n:'SA-13', name:'Boba Fett'},{n:'SA-14', name:'Boss Nass'},{n:'SA-15', name:'Bossk'},
      {n:'SA-16', name:'C-3PO'},{n:'SA-17', name:'Cad Bane'},{n:'SA-18', name:'Captain Phasma'},
      {n:'SA-19', name:'Cassian Andor'},{n:'SA-20', name:'Chewbacca'},{n:'SA-21', name:'Chirrut Îmwe'},
      {n:'SA-22', name:'Ciddarin Scaleback'},{n:'SA-23', name:'Cobb Vanth'},{n:'SA-24', name:'Count Dooku'},
      {n:'SA-25', name:'Darth Maul'},{n:'SA-26', name:'Darth Vader'},{n:'SA-27', name:'Dr. Pershing'},
      {n:'SA-28', name:'Drash'},{n:'SA-29', name:'Duchess Satine Kryze'},{n:'SA-30', name:'Emperor Palpatine'},
      {n:'SA-31', name:'Ezra Bridger'},{n:'SA-32', name:'Fennec Shand'},{n:'SA-33', name:'Fifth Brother'},
      {n:'SA-34', name:'Finn'},{n:'SA-35', name:'Garazeb Orrelios'},{n:'SA-36', name:'General Grievous'},
      {n:'SA-37', name:'Grand Admiral Thrawn'},{n:'SA-38', name:'Grand Moff Tarkin'},{n:'SA-39', name:'Grogu'},
      {n:'SA-40', name:'Gunter'},{n:'SA-41', name:'Han Solo'},{n:'SA-42', name:'Hondo Ohnaka'},
      {n:'SA-43', name:'IG-12'},{n:'SA-44', name:'Jango Fett'},{n:'SA-45', name:'Jar Jar Binks'},
      {n:'SA-46', name:'Jecki Lon'},{n:'SA-47', name:'Jod Na Nawood'},{n:'SA-48', name:'Kanan Jarrus'},
      {n:'SA-49', name:'Kelnacca'},{n:'SA-50', name:'Kino Loy'},{n:'SA-51', name:'Kit Fisto'},
      {n:'SA-52', name:'Koska Reeves'},{n:'SA-53', name:'Krrsantan'},{n:'SA-54', name:'Kuiil'},
      {n:'SA-55', name:'Kylo Ren'},{n:'SA-56', name:'Lando Calrissian'},{n:'SA-57', name:'Leia Organa'},
      {n:'SA-58', name:'Luke Skywalker'},{n:'SA-59', name:'Luminara Unduli'},{n:'SA-60', name:'Mace Windu'},
      {n:'SA-61', name:'Marrok'},{n:'SA-62', name:'Master Indara'},{n:'SA-63', name:'Master Torbin'},
      {n:'SA-64', name:'Max Rebo'},{n:'SA-65', name:'Mayor Mok Shaiz'},{n:'SA-66', name:'Maz Kanata'},
      {n:'SA-67', name:'Moff Gideon'},{n:'SA-68', name:'Mon Mothma'},{n:'SA-69', name:'NED-B'},
      {n:'SA-70', name:'Neel'},{n:'SA-71', name:'Obi-Wan Kenobi'},{n:'SA-72', name:'Omega'},
      {n:'SA-73', name:'Padmé Amidala'},{n:'SA-74', name:'Paz Vizsla'},{n:'SA-75', name:'Poe Dameron'},
      {n:'SA-76', name:'Pong Krell'},{n:'SA-77', name:"Qi'ra"},{n:'SA-78', name:'R2-D2'},
      {n:'SA-79', name:'Rey'},{n:'SA-80', name:'Sabine Wren'},{n:'SA-81', name:'Savage Opress'},
      {n:'SA-82', name:'Sergeant Mosk'},{n:'SA-83', name:'Seventh Sister'},{n:'SA-84', name:'Shaak Ti'},
      {n:'SA-85', name:'Shin Hati'},{n:'SA-86', name:'Sidon Ithano'},{n:'SA-87', name:'SM-33'},
      {n:'SA-88', name:'Sol'},{n:'SA-89', name:'Stormtrooper'},{n:'SA-90', name:'Supreme Leader Snoke'},
      {n:'SA-91', name:'The Armorer'},{n:'SA-92', name:'The Grand Inquisitor'},{n:'SA-93', name:'The Mandalorian'},
      {n:'SA-94', name:'The Stranger'},{n:'SA-95', name:'Vect Nokru'},{n:'SA-96', name:'Vel Sartha'},
      {n:'SA-97', name:'Vernestra Rwoh'},{n:'SA-98', name:'Yoda'},{n:'SA-99', name:'Zam Wessell'},
      {n:'SA-100', name:'Zorii Bliss'},
    ]
  },
  {
    id: 'triptych-sketch', type: 'sketch', title: 'TRIPTYCH SKETCH CARDS — 25 SCENES',
    cards: [
      {n:'TSC-1', name:'Duel of the Fates'},
      {n:'TSC-2', name:'The Battle of Geonosis'},
      {n:'TSC-3', name:'The Tragedy of Darth Plagueis the Wise'},
      {n:'TSC-4', name:'Twin Suns of Tatooine'},
      {n:'TSC-5', name:'The Trench Run'},
      {n:'TSC-6', name:'The Battle of Hoth'},
      {n:'TSC-7', name:'The Duel on Cloud City'},
      {n:'TSC-8', name:'Ewoks capture Luke Skywalker, Han Solo, R2-D2, and C-3PO'},
      {n:'TSC-9', name:'Obi-Wan vs Darth Vader in the Death Star'},
      {n:'TSC-10', name:'Escape from Jakku on the Millenium Falcon'},
      {n:'TSC-11', name:'Rey and Kylo Ren vs Praetorian Guards'},
      {n:'TSC-12', name:'Ahsoka in the graveyard of fallen soldiers'},
      {n:'TSC-13', name:'Obi-Wan vs Maul on Tatooine'},
      {n:'TSC-14', name:'Luke cutting through Dark Troopers'},
      {n:'TSC-15', name:'The Sand Beast'},
      {n:'TSC-16', name:'Ahsoka vs Anakin in the World Between Worlds'},
      {n:'TSC-17', name:'Ahsoka, Sabine, Ezra team up'},
      {n:'TSC-18', name:'The Skeleton Crew race to save their home'},
      {n:'TSC-19', name:'The Skeleton Crew and Jod'},
      {n:'TSC-20', name:'Captain Brutus and his pirates'},
      {n:'TSC-21', name:'Leia Organa in the Yavin IV control room'},
      {n:'TSC-22', name:'Mace Windu and Jedi confront Palpatine'},
      {n:'TSC-23', name:'Luke defeats the Rancor'},
      {n:'TSC-24', name:'Luke and Obi-Wan speak to Han Solo and Chewbacca in the Cantina'},
      {n:'TSC-25', name:'General Grievous vs Obi-Wan'},
    ]
  },
];

// Combined parallel list for the filter dropdown, grouped by sub-set.
// The `group` field drives <optgroup> labels in the Checklist dropdown.
export const PARALLELS = [
  // Finest Base
  { id: 'refractor',      name: 'Refractor',              odds: '1:1',   print_run: null, color: '#c8d8f0', group: 'Finest Base Set' },
  { id: 'green',          name: 'Green Refractor',         odds: '1:4',   print_run: null, color: '#00e676', group: 'Finest Base Set' },
  { id: 'purple-lazer',   name: 'Purple Lazer Refractor',  odds: '1:5',   print_run: null, color: '#ce93d8', group: 'Finest Base Set' },
  { id: 'gold',           name: 'Gold Refractor',          odds: '1:7',   print_run: null, color: '#f0c040', group: 'Finest Base Set' },
  { id: 'orange',         name: 'Orange Refractor',        odds: '1:13',  print_run: null, color: '#ff9100', group: 'Finest Base Set' },
  { id: 'black',          name: 'Black Refractor',         odds: '1:31',  print_run: null, color: '#616161', group: 'Finest Base Set' },
  { id: 'red',            name: 'Red Refractor',           odds: '1:62',  print_run: null, color: '#ff1744', group: 'Finest Base Set' },
  { id: 'superfractor',   name: 'Superfractor',            odds: '1:313', print_run: 1,    color: '#ffd700', group: 'Finest Base Set' },
  // Chrome Black
  { id: 'cb-gold',           name: 'Gold Refractor',       odds: '1:7',   print_run: null, color: '#f0c040', group: 'Chrome Black' },
  { id: 'cb-orange',         name: 'Orange Refractor',     odds: '1:13',  print_run: null, color: '#ff9100', group: 'Chrome Black' },
  { id: 'magenta-ray-wave',  name: 'Magenta Ray Wave Refractor',     odds: '1:31',  print_run: null, color: '#e91e63', group: 'Chrome Black' },
  { id: 'cb-red',            name: 'Red Refractor',        odds: '1:62',  print_run: null, color: '#ff1744', group: 'Chrome Black' },
  { id: 'cb-superfractor',   name: 'Superfractor',         odds: '1:313', print_run: 1,    color: '#ffd700', group: 'Chrome Black' },
  // Galactic Antiquities
  { id: 'blue-foil',       name: 'Blue Foil',              odds: '1:10',  print_run: null, color: '#2979ff', group: 'Galactic Antiquities' },
  { id: 'orange-foil',     name: 'Orange Foil',            odds: '1:19',  print_run: null, color: '#ff9100', group: 'Galactic Antiquities' },
  { id: 'black-foil',      name: 'Black Foil',             odds: '1:46',  print_run: null, color: '#616161', group: 'Galactic Antiquities' },
  { id: 'red-foil',        name: 'Red Foil',               odds: '1:93',  print_run: null, color: '#ff1744', group: 'Galactic Antiquities' },
  { id: 'gold-foil',       name: 'Gold Foil',              odds: '1:472', print_run: null, color: '#f0c040', group: 'Galactic Antiquities' },
  { id: 'hyperspace-foil', name: 'Hyperspace Foil',        odds: '1:472', print_run: null, color: '#00e5ff', group: 'Galactic Antiquities' },
  // Inserts
  { id: 'ins-green',  name: 'Green Refractor',         odds: '1:10',  print_run: null, color: '#00e676', group: 'Inserts' },
  { id: 'ins-gold',   name: 'Gold Refractor',          odds: '1:19',  print_run: null, color: '#f0c040', group: 'Inserts' },
  { id: 'ins-orange', name: 'Orange Refractor',        odds: '1:38',  print_run: null, color: '#ff9100', group: 'Inserts' },
  { id: 'ins-black',  name: 'Black Refractor',         odds: '1:93',  print_run: null, color: '#616161', group: 'Inserts' },
  { id: 'ins-red',    name: 'Red Refractor',           odds: '1:187', print_run: null, color: '#ff1744', group: 'Inserts' },
  { id: 'ins-super',  name: 'Superfractor',            odds: '1:924', print_run: 1,    color: '#ffd700', group: 'Inserts' },
  // Autographs
  { id: 'auto-blue-red-lava', name: 'Blue/Red Lava Refractor', odds: '1:13',  print_run: null, color: '#4fc3f7', group: 'Autographs' },
  { id: 'auto-gold',          name: 'Gold Refractor',          odds: '1:26',  print_run: null, color: '#f0c040', group: 'Autographs' },
  { id: 'auto-orange',        name: 'Orange Refractor',        odds: '1:46',  print_run: null, color: '#ff9100', group: 'Autographs' },
  { id: 'auto-magenta',       name: 'Magenta Ray Wave Refractor',        odds: '1:78',  print_run: null, color: '#e91e63', group: 'Autographs' },
  { id: 'auto-red',           name: 'Red Refractor',           odds: '1:94',  print_run: null, color: '#ff1744', group: 'Autographs' },
  { id: 'auto-plate-cyan',    name: 'Printing Plate Cyan',     odds: '1:172', print_run: 1,    color: '#00e5ff', group: 'Autographs' },
  { id: 'auto-plate-magenta', name: 'Printing Plate Magenta',  odds: '1:172', print_run: 1,    color: '#e91e63', group: 'Autographs' },
  { id: 'auto-plate-yellow',  name: 'Printing Plate Yellow',   odds: '1:172', print_run: 1,    color: '#ffee58', group: 'Autographs' },
  { id: 'auto-plate-black',   name: 'Printing Plate Black',    odds: '1:172', print_run: 1,    color: '#616161', group: 'Autographs' },
  { id: 'auto-super',         name: 'Superfractor',            odds: '1:442', print_run: 1,    color: '#ffd700', group: 'Autographs' },
];
